var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM12 7c1.179 0 2.311.423 3.205 1.17l-2.322 2.322 6.211.54-.539-6.212-1.93 1.93A7.014 7.014 0 0 0 12 5a6.975 6.975 0 0 0-6.903 5.834l1.973.331A4.98 4.98 0 0 1 12 7zm-3.205 8.83A5.004 5.004 0 0 0 12 17a4.98 4.98 0 0 0 4.93-4.165l1.973.331A6.975 6.975 0 0 1 12 19a7.014 7.014 0 0 1-4.625-1.75l-1.93 1.93-.539-6.21 6.211.538-2.322 2.322z"
  })));
};
export default SvgRefresh;